<template>
  <div class="user">
    <NavBtn :on-click="back" />
    <div class="icon">
      <img :src="avatar_src" alt="">
    </div>
    <div class="user-info double-row">
      <div>
        <span class="name">用户ID</span>
        <span class="value">{{userInfo.uid}}</span>
      </div>
      <div @click="forward()">
        <span class="name">手机号码</span>
        <span class="to">
        </span>
        <span class="value">{{userInfo.mobile}}</span>
      </div>
      <div @click="toWechat()">
        <span class="wechat" >微信</span>
        <span class="to">
        </span>
        <span class="value"
           v-if="(!!userInfo.wechat_info.wechat_realname || '')" v-text="userInfo.wechat_info.wechat_realname"></span>
        <em v-else>绑定</em>
      </div>
    </div>
    <div class="question row" @click="$refs.bindWx.show()">
      <span>客服</span>
      <span class="icon-question">
      </span>
    </div>
    <!-- <div class="login row" @click="toggleAccount()">
      <span>切换账户</span>
    </div> -->
    <BindWxDialog ref="bindWx" />
    <ChangeMobileDialog ref="changeWarning" />
  </div>
</template>
<style lang='scss' scoped>
  .user {
    background-color: #3A4E92;
    height: 100%;
    padding-top: 50px;

    .back {
      position: absolute;
      top: 16px;
      left: 20px;
      width: 40px;
      height: 40px;
      background: #342F74;
      box-shadow: 0 3px 5px 0 #36308E;
      border-radius: 50%;
    }

    .icon {
      height: 80px;
      text-align: center;
      margin-bottom:40px;

      img {
        width: 80px;
        height: 80px;
        border-radius: 100%;
      }
    }

    .remind {
      text-align: center;
      font-size: 13px;
      color: #FFFFFF;
      margin-bottom: 40px;

      @include regular();
    }
    .double-row{
      height: auto;
    }
    .user-info {
      margin: 0 auto 10px;
      overflow: hidden;
      // height: 151px;

      div {
        padding-right: 15px;
      }


      .name {
        font-size: 13px;
        color: #3A3A3A;

        @include regular();
      }

      .value {
        float: right;
        font-size: 13px;
        color: #B5B5B5;
        @include regular();

      }

      .to {
        float: right;
        color: #B5B5B5;
        margin-left: 10px;
        img {
          width: 8px;
          height: 20px;
          vertical-align: middle;
        }
      }

      .wechat, .zhifubao{
        font-size: 13px;
        color: #3A3A3A;

        @include regular();
      }

      em{
        font-style: normal;
        color:#B5B5B5;
        font-size:13px;
        float:right;
        padding-top: 1px;

        @include regular();
      }
    }

    .question, .login{
      margin: 0 auto 10px;
      padding-left: 15px;
      font-size: 13px;
      color: #3A3A3A;

      @include regular();

      .icon-question {
        position: relative;
        margin-right: 15px;
        top: 50%;
        transform: translateY(-50%);
        float: right;
        width: 20px;
        height: 20px;

        img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
</style>
<script>
  import { mapState, mapActions } from 'vuex'
  import BindWxDialog from './BindWxDialog'
  import ChangeMobileDialog from './ChangeMobileDialog'
  import { URI_GET_USERINFO } from '@/store/modules/user/type'

  export default {
    components: {
      BindWxDialog,
      ChangeMobileDialog
    },
    computed: {
      ...mapState({
        userInfo: state => state.user.userInfo,
        avatar: state => state.user.userInfo.portrait
      }),
      'avatar_src': function () {
        return this.avatar === ''
          ? '//cdn.hongbaoxd.com/images/1e0321415339235c0913e001c71aa762.png'
          : this.avatar
      }
    },
    async mounted () {
      await this.getUserInfo()
    },
    methods: {
      ...mapActions({
        getUserInfo: URI_GET_USERINFO
      }),
      back () {
        this.$router.push('/dashboard')
      },
      forward () {
        this.$router.push('/bindMobile')
      },
      // toAlipay () {
      //   if (this.userInfo.ali_info.ali_account !== '') {
      //     this.$router.push('/alipaychange')
      //   } else {
      //     this.$router.push('/alipaybinding')
      //   }
      // },
      // toggleAccount () {
      //   if (!this.userInfo.mobile) {
      //     this.$refs.changeWarning.show()
      //   } else {
      //     this.$router.push('/swichuser')
      //   }
      // },
      toWechat () {
        this.$router.push('/BindWechat')
      }
    }
  }
</script>
